import { Component, Input } from '@angular/core';
import { AccommodationType, SaleType } from '../ngrx-store/app.state';

@Component({
  selector: 'app-feed-content',
  templateUrl: './feed-content.component.html',
  styleUrls: ['./feed-content.component.css']
})
export class FeedContentComponent {

  @Input() post!: AccommodationType | SaleType;
  
}
